import http from './http'

/**
 * 获取元数据
 */

export const getMetaData = (): Promise<{
  env: string[]
  namespacePermissions: string[]
}> => {
  return http.get('/manager/metadata')
}
